"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.appendQueryParamToUrl = exports.getClientProperties = exports.getAnalyticsClient = exports.getExternalScriptClient = exports.loadExternalScript = exports.getBrowserName = exports.getOsName = exports.getCookie = exports.getGlobal = exports.setGlobal = exports.isServer = void 0;
var wurfl_1 = __importDefault(require("./wurfl"));
var isServer = typeof window === 'undefined';
exports.isServer = isServer;
var noop = function () { return undefined; };
function getGlobal(globalProp) {
    if (isServer) {
        if (typeof global !== 'undefined') {
            return global[globalProp];
        }
        return undefined;
    }
    return window[globalProp];
}
exports.getGlobal = getGlobal;
function getCookie(cookieName) {
    if (isServer)
        return undefined;
    var cookie = (document.cookie
        .split('; ')
        .map(function (str) { return str.split('='); })
        .find(function (_a) {
        var name = _a[0];
        return name === cookieName;
    }) || [])[1];
    if (cookie !== undefined) {
        return cookie.replace(/(%[0-9A-Z]{2})+/g, decodeURIComponent);
    }
    return cookie;
}
exports.getCookie = getCookie;
function getOsName() {
    if (isServer)
        return '';
    if (window.navigator.appVersion.indexOf('Win') !== -1) {
        return 'Windows';
    }
    if (window.navigator.appVersion.indexOf('Mac') !== -1) {
        return 'MacOS';
    }
    if (window.navigator.appVersion.indexOf('X11') !== -1) {
        return 'UNIX';
    }
    if (window.navigator.appVersion.indexOf('Linux') !== -1) {
        return 'Linux';
    }
    return 'Unknown OS';
}
exports.getOsName = getOsName;
function getBrowserName() {
    if (isServer)
        return '';
    var useragent = window.navigator.userAgent;
    var revision = null;
    var matchedName = useragent.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];
    if (/trident/i.test(matchedName[1])) {
        revision = /\brv[ :]+(\d+)/g.exec(useragent) || [];
        return "IE " + (revision[1] || '');
    }
    if (matchedName[1] === 'Chrome') {
        revision = useragent.match(/\bOPR\/(\d+)/);
        if (revision !== null) {
            return "Opera " + revision[1];
        }
    }
    matchedName = matchedName[2]
        ? [matchedName[1], matchedName[2]]
        : [window.navigator.appName, window.navigator.appVersion, '-?'];
    revision = useragent.match(/version\/(\d+)/i);
    if (revision !== null) {
        matchedName.splice(1, 1, revision[1]);
    }
    return matchedName.join(' ');
}
exports.getBrowserName = getBrowserName;
function getClientProperties() {
    return __awaiter(this, void 0, void 0, function () {
        var WURFL;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (isServer)
                        return [2 /*return*/, {}];
                    return [4 /*yield*/, wurfl_1.default()];
                case 1:
                    WURFL = _a.sent();
                    return [2 /*return*/, {
                            browser: getBrowserName(),
                            os: getOsName(),
                            deviceCategory: WURFL && WURFL.form_factor,
                            deviceName: WURFL && WURFL.complete_device_name,
                            referrer: document.referrer,
                            language: navigator.language,
                            screenResolution: window.screen.width + "x" + window.screen.height,
                            browserResolution: window.innerWidth + "x" + window.innerHeight,
                            url: window.location.href
                        }];
            }
        });
    });
}
exports.getClientProperties = getClientProperties;
function setGlobal(key, val) {
    if (isServer)
        return;
    window[key] = val;
    // eslint-disable-next-line consistent-return
    return window[key];
}
exports.setGlobal = setGlobal;
function loadExternalScript(url, globalProp, callback) {
    var _this = this;
    if (callback === void 0) { callback = noop; }
    return new Promise(function (resolve, reject) {
        var script = document.createElement('script');
        script.type = 'text/javascript';
        script.async = true;
        script.onload = function () { return __awaiter(_this, void 0, void 0, function () {
            var result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, callback(window[globalProp])];
                    case 1:
                        result = _a.sent();
                        if (!window[globalProp]) {
                            setGlobal(globalProp, result);
                        }
                        resolve(window[globalProp]);
                        return [2 /*return*/];
                }
            });
        }); };
        script.onerror = reject;
        script.src = url;
        document.body.appendChild(script);
    });
}
exports.loadExternalScript = loadExternalScript;
var getExternalScriptClient = function (globalProp, url, callback) {
    if (callback === void 0) { callback = noop; }
    if (!globalProp || isServer) {
        return undefined;
    }
    if (url && !window[globalProp]) {
        return loadExternalScript(url, globalProp, callback).catch(function () {
            console.error("unable to load " + url + " script");
            return null;
        });
    }
    callback(window[globalProp]);
    return window[globalProp];
};
exports.getExternalScriptClient = getExternalScriptClient;
function getAnalyticsClient(globalProp, url, callback) {
    if (callback === void 0) { callback = noop; }
    return getExternalScriptClient(globalProp, url, callback);
}
exports.getAnalyticsClient = getAnalyticsClient;
function appendQueryParamToUrl(url, param, value) {
    if (url === void 0) { url = ''; }
    var operator = url.includes('?') ? '&' : '?';
    return "" + url + operator + param + "=" + value;
}
exports.appendQueryParamToUrl = appendQueryParamToUrl;
